import { useEffect } from 'react';
import Link from 'next/link';
import cn from 'classnames';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import { useLocale } from '@/context/LocaleContext';

gsap.registerPlugin(ScrollTrigger);

const BotonFooter = ({ label, glass = 'hidden', route = '/' }) => {
  const locale = useLocale();

  return (
    <Link
      href={route}
      locale={locale}
      className="flex items-center justify-center w-full relative py-16 sm:py-10 px-26 bg-white rounded-full group"
    >
      <svg
        className={cn('flex-shrink-0 mr-5', glass)}
        width="20"
        height="22"
        viewBox="0 0 20 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          className="group-hover:stroke-[#ee4424] duration-40"
          cx="11.3992"
          cy="9.31519"
          r="8.05151"
          stroke="#064246"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <line
          className="group-hover:stroke-[#ee4424] duration-40"
          x1="0.65625"
          y1="20.9198"
          x2="5.85671"
          y2="15.7194"
          stroke="#064246"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>

      <p
        className={cn(
          'p1 !text-11 !font-semibold text-black relative z-3 uppercase text-center whitespace-nowrap group-hover:text-red duration-40'
        )}
      >
        {label}
      </p>
    </Link>
  );
};
export default BotonFooter;
